var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',[_c('SpadefootQuiz')],1),_c('a',{attrs:{"id":"back2Top","title":"Back to top","href":"#"}},[_vm._v("➤")])])}
var staticRenderFns = []

export { render, staticRenderFns }